module.exports = __webpack_public_path__ + "static/img/privacy_count_4.b5e2c7c4.svg";